var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.topLevelActions, function(action) {
        return [
          _c(action.component, {
            tag: "component",
            attrs: {
              config: action,
              changeUrl: _vm.changeUrl,
              changeQuery: _vm.changeQuery,
              changeSection: _vm.changeSection,
              addNotification: _vm.addNotification
            }
          })
        ]
      }),
      _vm._v(" "),
      _vm._.get(_vm.config, "creatable", true)
        ? _c(
            "button",
            {
              staticClass: "btn btn-rounded btn-icon btn-success",
              attrs: { type: "button" },
              on: { click: _vm.loadNewInstance }
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
              _vm._v(
                "Add " + _vm._s(_vm.__(_vm.type, ["titleCase"])) + "\n    "
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18643784", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18643784","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/ToplevelToolbarComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-18643784","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/ToplevelToolbarComponent.vue
// module chunks = 0